export default "__VITE_ASSET__6ddc633c__"